const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

const toIst = (date) => new Date(date.getTime() + IST_OFFSET_MS);
const fromIst = (date) => new Date(date.getTime() - IST_OFFSET_MS);

export const getCurrentTradingDayStart = (now = new Date()) => {
    const nowIst = toIst(now);
    const startIst = new Date(nowIst);
    startIst.setHours(5, 0, 0, 0);
    if (nowIst < startIst) {
        startIst.setDate(startIst.getDate() - 1);
    }
    return fromIst(startIst);
};

export const getNextTradingDayReset = (now = new Date()) => {
    const nowIst = toIst(now);
    const targetIst = new Date(nowIst);
    targetIst.setHours(5, 0, 0, 0);
    if (nowIst >= targetIst) {
        targetIst.setDate(targetIst.getDate() + 1);
    }
    return fromIst(targetIst);
};

